var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg36(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4466_96589)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.6943 2.85065L21.6493 10.8056M13.6943 2.85065C15.891 0.653949 19.4526 0.653949 21.6493 2.85065C23.846 5.04736 23.846 8.60892 21.6493 10.8056M13.6943 2.85065C12.5248 4.02023 11.978 5.57671 12.0538 7.10807M21.6493 10.8056C20.4797 11.9752 18.9232 12.5219 17.3919 12.4461M12.0538 7.10807L0.945312 20.7922L3.7078 23.5546L17.3919 12.4461M12.0538 7.10807L17.3919 12.4461M2.72745 18.5968L5.90314 21.7725M6.10902 14.4312C5.20016 15.5508 5.28434 17.1762 6.30402 18.1959C7.32373 19.2156 8.94908 19.2998 10.0687 18.3909M10.2717 9.30342L15.1965 14.2282",
    stroke: "black",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4466_96589"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg36);
export default __webpack_public_path__ + "static/media/36.01db569eec49916bf6e726d09b4c178b.svg";
export { ForwardRef as ReactComponent };